export class EstadoDoProcesso {

  Id: number;
  Descricao: string;
  Ativo: boolean;
  EncerradoOuInativo: boolean;

  constructor() {
    this.Id = 0;
    this.Descricao = '';
    this.Ativo = true;
    this.EncerradoOuInativo = false;
  }
}
